module.exports = __webpack_public_path__ + "img/woshou.367fb8b2.png";